import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { MonitoredAssuntoEyeIcon } from '../MonitoredAssuntoEyeIcon';
import { MonitoredAgencyIcon } from '../MonitoredAgencyIcon';

export interface ChangeMonitoringBadgeFields {
  is_assunto_monitored?: boolean;
  monitored_assunto_label?: string | null;
  is_norm_monitored?: boolean;
  is_keyword_monitored?: boolean;
  monitored_keyword_label?: string | null;
  is_agency_monitored?: boolean;
  monitored_agency_label?: string | null;
}

interface Props extends ChangeMonitoringBadgeFields {
  stopPropagation?: boolean;
}

/** Ícones na coluna Ações — olho (assunto/norma individual), prédio (agência), chip (palavra-chave). */
export function ChangeMonitoringBadges({
  is_assunto_monitored,
  monitored_assunto_label,
  is_norm_monitored,
  is_keyword_monitored,
  monitored_keyword_label,
  is_agency_monitored,
  monitored_agency_label,
  stopPropagation = true,
}: Props) {
  return (
    <>
      {is_assunto_monitored ? (
        <MonitoredAssuntoEyeIcon
          assuntoLabel={monitored_assunto_label}
          stopPropagation={stopPropagation}
        />
      ) : null}
      {is_norm_monitored ? (
        <MonitoredAssuntoEyeIcon
          tooltipTitle="Norma monitorada individualmente"
          stopPropagation={stopPropagation}
        />
      ) : null}
      {is_keyword_monitored ? (
        <Tooltip
          title={
            monitored_keyword_label
              ? `Palavra-chave monitorada: ${monitored_keyword_label}`
              : 'Palavra-chave monitorada'
          }
          arrow
        >
          <Chip
            label={monitored_keyword_label ? `«${monitored_keyword_label}»` : 'Palavra-chave'}
            size="small"
            color="warning"
            variant="outlined"
            onClick={stopPropagation ? (event) => event.stopPropagation() : undefined}
            sx={{ height: 22, fontSize: '0.65rem', maxWidth: 88 }}
          />
        </Tooltip>
      ) : null}
      {is_agency_monitored ? (
        <MonitoredAgencyIcon
          agencyLabel={monitored_agency_label}
          stopPropagation={stopPropagation}
        />
      ) : null}
    </>
  );
}
